var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9983 16.5C10.8173 16.5011 10.6379 16.4664 10.4704 16.398C10.3029 16.3295 10.1505 16.2287 10.022 16.1013L4.52203 10.6013C4.29677 10.3382 4.17907 9.99989 4.19243 9.65384C4.2058 9.30778 4.34926 8.97952 4.59414 8.73464C4.83902 8.48976 5.16728 8.3463 5.51334 8.33293C5.85939 8.31957 6.19775 8.43728 6.46078 8.66254L10.9983 13.1863L15.522 8.66254C15.7851 8.43728 16.1234 8.31957 16.4695 8.33293C16.8155 8.3463 17.1438 8.48976 17.3887 8.73464C17.6336 8.97952 17.777 9.30778 17.7904 9.65384C17.8038 9.99989 17.686 10.3382 17.4608 10.6013L11.9608 16.1013C11.7047 16.3553 11.359 16.4985 10.9983 16.5Z",
    fill: "#FF725E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.5C10.6353 16.5 10.2856 16.3551 10.0277 16.0973C9.76987 15.8394 9.625 15.4897 9.625 15.125V1.375C9.625 1.01033 9.76987 0.660591 10.0277 0.402728C10.2856 0.144866 10.6353 0 11 0C11.3647 0 11.7144 0.144866 11.9723 0.402728C12.2301 0.660591 12.375 1.01033 12.375 1.375V15.125C12.375 15.4897 12.2301 15.8394 11.9723 16.0973C11.7144 16.3551 11.3647 16.5 11 16.5ZM20.625 22H1.375C1.01033 22 0.660591 21.8551 0.402728 21.5973C0.144866 21.3394 0 20.9897 0 20.625C0 20.2603 0.144866 19.9106 0.402728 19.6527C0.660591 19.3949 1.01033 19.25 1.375 19.25H11H20.625C20.9897 19.25 21.3394 19.3949 21.5973 19.6527C21.8551 19.9106 22 20.2603 22 20.625C22 20.9897 21.8551 21.3394 21.5973 21.5973C21.3394 21.8551 20.9897 22 20.625 22Z",
    fill: "#FF725E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.24ee60ca31f648991aa0a80c5f456f17.svg";
export { ForwardRef as ReactComponent };